import { EmailHistorySection } from "@/modules/email-templates-sidebar/content/v2/sections/email-history-section";

export const EmailTemplatesSidebarHistoryTab = () => {
  return (
    <section className="h-auto min-h-full bg-black/5 px-11 py-8">
      <EmailHistorySection />
    </section>
  );
};
